import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@els/els-react--button';
import CitedByWrapper from './CitedByWrapper';
import PatentTitle from './PatentTitle';

function PatentTitleFamilyMember({ title, onClick, getTrackingAttrs, abstractExpanded }) {
  return (
    <CitedByWrapper>
      <span>
        <Button
          data-e2e="patent-family-member-title"
          type="link"
          onClick={onClick}
          linkOptions={['navigation']}
          className="patent-content__title-button e2e-document-action-title"
          {...getTrackingAttrs({
            'data-tracking': !abstractExpanded,
            'data-tracking-type': 'contentlinkclick',
            'data-tracking-action': 'title',
          })}>
          <PatentTitle title={title} tag="h3" className="patent-content__title--family-member" />
        </Button>
      </span>
    </CitedByWrapper>
  );
}

PatentTitleFamilyMember.propTypes = {
  title: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  getTrackingAttrs: PropTypes.func.isRequired,
  abstractExpanded: PropTypes.bool,
};

export default PatentTitleFamilyMember;
